import { css, html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { litIf } from "./LitUtils";

export enum InfoBadgeType {
    Info = "info",
    Warning = "warning",
    Danger = "danger",
}

export type InfoBadgeData = {
    title: string | undefined;
    text: string | undefined;
    type: InfoBadgeType;
};

@customElement("ds-info-badge")
export class InfoBadge extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                width: auto;
                border: 1px solid lightgrey;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0.5em;
                border-radius: 0.5em;
                justify-content: center;
                background-color: #ecedef;
            }

            .danger {
            }
            .warning {
            }
            .info {
            }

            .invalid-type {
            }

            .title {
                font-variant-caps: all-petite-caps;
                font-weight: bold;
            }
            .text {
                font-variant-caps: all-petite-caps;
            }

            span {
                color: black;
                font-size: 1em;
            }

            hr {
                width: 100%;
                margin-top: 0.2em;
                margin-bottom: 0.2em;
            }
        `,
    ];
    @property({ type: Object }) badge: InfoBadgeData | undefined;

    override render() {
        return html` ${litIf(
            !!this.badge,
            () =>
                html`<div class="container">
                    <span class="title">${ifDefined(this.badge?.title)}</span>
                    ${litIf(!!this.badge?.title && !!this.badge.text, () => html`<hr />`)}
                    <span class="text">${ifDefined(this.badge?.text)}</span>
                </div>`
        )}`;
    }
}

@customElement("ds-info-badges")
export class InfoBadges extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .container {
                flex-wrap: wrap;
                justify-content: center;
            }
        `,
    ];
    @property({ type: Array }) badges: InfoBadgeData[] | undefined;

    override render() {
        return html`<div class="container flex-row">
            ${litIf(
                !!this.badges,
                () =>
                    html`${this.badges?.map(
                        (b) => html`<ds-info-badge .badge=${b}></ds-info-badge>`
                    )}`
            )}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-info-badges": InfoBadges;
        "ds-info-badge": InfoBadge;
    }
}
